import React from "react";
import clsx from "clsx";

import { Theme } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import FacilityIcon from "components/Icons/Facility";

import useStyles from "./styles";

interface IProps {
  facility: racehorse360.IFacility;
  isSelected: boolean;
  onFacilitySelect: (facility: racehorse360.IFacility) => void;
}

const FacilitySelectOption = (props: IProps) => {
  const { facility, isSelected, onFacilitySelect } = props;

  const classes = useStyles({
    foregroundColor: facility?.foregroundColor
  });
  const matchesUpLg = useMediaQuery((theme: Theme) =>
    theme.breakpoints.up("lg")
  );

  return (
    <ListItem
      button
      divider
      key={`${facility.id}-option`}
      className={clsx(classes.listItem, {
        [classes.listItemSmall]: matchesUpLg
      })}
      onClick={() => onFacilitySelect(facility)}
    >
      <ListItemIcon className={classes.listItemIcon}>
        <FacilityIcon
          selected={isSelected}
          code={facility.code.trim()}
          backgroundColor={facility.backgroundColor}
          strokeColor={facility.strokeColor}
        />
      </ListItemIcon>
      <ListItemText
        primary={`${facility.name} (${facility.code.trim()})`}
        classes={{ primary: classes.listItemText }}
        className={clsx({
          [classes.listItemSelected]: isSelected
        })}
      />
    </ListItem>
  );
};

export default React.memo(FacilitySelectOption);
